function getSortFromURL(value) {
  return [
    'price',
    'price-desc',
    'deductible',
    'deductible-desc',
    'moop',
    'moop-desc'
  ].includes(value)
    ? value
    : ''
}

export default getSortFromURL
